export default {
  'auth.add.user': 'Gebruiker toevoegen',
  'auth.create.account': 'Maak account',
  'auth.create.an.account': 'Maak een account',
  'auth.error.username.empty': 'Gebruikersnaam mag niet leeg zijn.',
  'auth.log.in': 'Log in',
  'auth.login': 'Login',
  'auth.password': 'Wachtwoord',
  'auth.user.accounts': 'Accounts',
  'auth.username': 'Gebruikersnaam',

  'button.add': 'Toevoegen',
  'button.cancel': 'Annuleren',
  'button.no': 'Nee',
  'button.save': 'Instellingen opslaan',
  'button.state.adding': 'Toevoegen...',
  'button.yes': 'Ja',

  'feeds.add.automatic.download.rule': 'Regel toevoegen',
  'feeds.add.feed': 'Feed toevoegen',
  'feeds.applicable.feed': 'Feed',
  'feeds.apply.tags': 'Tags toevoegen',
  'feeds.exclude.pattern': 'Overslaan op patroon',
  'feeds.existing.feeds': 'Feeds',
  'feeds.existing.rules': 'Regels',
  'feeds.label': 'Label',
  'feeds.match.count': `{count, plural, =1 {# match} other {# matches}}`,
  'feeds.match.pattern': 'Match op patroon',
  'feeds.match': 'Match',
  'feeds.no.feeds.available': 'Geen feeds beschikbaar.',
  'feeds.no.feeds.defined': 'Geen feeds toegevoegd.',
  'feeds.no.rules.defined': 'Geen regels toegevoegd.',
  'feeds.regEx': 'RegEx',
  'feeds.select.feed': 'Selecteer feed',
  'feeds.select.interval': 'Interval',
  'feeds.start.on.load': 'Start na toevoegen',
  'feeds.tabs.download.rules': 'Regels',
  'feeds.tabs.feeds': 'Feeds',
  'feeds.tabs.heading': 'Torrent feeds',
  'feeds.tags': 'Tags',
  'feeds.time.hr': '{durationValue} uur',
  'feeds.time.min': '{durationValue} min',
  'feeds.torrent.destination': 'Torrent downloadlocatie',
  'feeds.url': 'URL',
  'feeds.validation.invalid.regular.expression': 'Fout in regular expression.',
  'feeds.validation.must.select.feed': 'Je moet een feed selecteren.',
  'feeds.validation.must.specify.destination': 'Je moet een downloadlocatie opgeven.',
  'feeds.validation.must.specify.label': 'Je moet een label selecteren.',
  'feeds.validation.must.specify.valid.feed.url': 'Je moet een geldige feed URL opgeven.',

  'filter.all': 'Alles',
  'filter.status.title': 'Filter op status',
  'filter.status.downloading': 'Downloaden',
  'filter.status.completed': 'Klaar',
  'filter.status.active': 'Actief',
  'filter.status.inactive': 'Inactief',
  'filter.status.error': 'Fout',
  'filter.tracker.title': 'Filter op tracker',
  'filter.tag.title': 'Filter op tag',
  'filter.untagged': 'Niet getagd',

  'locale.language.en': 'English',
  'locale.language.fr': 'Frans',
  'locale.language.nl': 'Nederlands',

  'alert.torrent.add': `Het toevoegen van {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  } is klaar.`,
  'alert.torrent.add.failed': `Het toevoegen van {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  } is mislukt.`,
  'alert.torrent.move': `Het verplaatsen van {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  } is klaar.`,
  'alert.torrent.move.failed': `Het verplaatsen van {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  } is mislukt.`,
  'alert.torrent.remove': `Het verwijderen van {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  } is klaar.`,
  'alert.torrent.remove.failed': `Het verwijderen van {countElement} {count, plural,
    =1 {torrent}
    other {torrents}
  } is mislukt.`,
  'alert.settings.saved': 'Instellingen zijn opgeslagen.',

  'priority.dont.download': 'Niet downloaden',
  'priority.high': 'Hoog',
  'priority.low': 'Laag',
  'priority.normal': 'Normaal',

  'settings.bandwidth.slots.download.divider.label': 'Download slots divider',
  'settings.bandwidth.slots.download.global.label': 'Download slots globaal',
  'settings.bandwidth.slots.download.label': 'Download slots per torrent',
  'settings.bandwidth.slots.heading': 'Slots',
  'settings.bandwidth.slots.upload.divider.label': 'Upload slots divider',
  'settings.bandwidth.slots.upload.global.label': 'Upload slots globaal',
  'settings.bandwidth.slots.upload.label': 'Upload slots per torrent',
  'settings.bandwidth.transferrate.dropdown.preset.download.label': 'Dropdown downloadbeperking items',
  'settings.bandwidth.transferrate.dropdown.preset.upload.label': 'Dropdown uploadbeperking items',
  'settings.bandwidth.transferrate.global.throttle.download': 'Globale downloadbeperking',
  'settings.bandwidth.transferrate.global.throttle.upload': 'Gobale uploadbeperking',
  'settings.bandwidth.transferrate.heading': 'Sneldheidsbeperkingen',

  'settings.connectivity.dht.label': 'Gebruik DHT',
  'settings.connectivity.dht.port.label': 'DHT Poort',
  'settings.connectivity.dpd.heading': 'Decentralized Peer Discovery',
  'settings.connectivity.incoming.heading': 'Inkomende connecties',
  'settings.connectivity.ip.hostname.label': 'Vermeld IP/Hostnaam',
  'settings.connectivity.max.http.connections': 'Maximaal aantal HTTP connecties',
  'settings.connectivity.peer.exchange.label': 'Gebruik Peer Exchange',
  'settings.connectivity.peers.desired.label': 'Gewenst aantal peers',
  'settings.connectivity.peers.heading': 'Peers',
  'settings.connectivity.peers.max.label': 'Maximaal aantal peers',
  'settings.connectivity.peers.min.label': 'Minimaal aantal peers',
  'settings.connectivity.peers.seeding.max.label': 'Maximaal aantal peers seeding',
  'settings.connectivity.peers.seeding.min.label': 'Minimaal aantal peers seeding',
  'settings.connectivity.port.open.label': 'Open poort',
  'settings.connectivity.port.randomize.label': 'Willekeurige poort',
  'settings.connectivity.port.range.label': 'Poortbereik',

  'settings.resources.disk.check.hash.label': 'Controleer hash na downloaden',
  'settings.resources.disk.download.location.label': 'Standaard downloadlocatie',
  'settings.resources.disk.heading': 'Disk',
  'settings.resources.max.open.files': 'Maximaal aantal open bestanden',
  'settings.resources.memory.heading': 'Geheugen',
  'settings.resources.memory.max.label': 'Maximaal geheugengebruik',

  'settings.tabs.bandwidth': 'Bandbreedte',
  'settings.tabs.connectivity': 'Connectiviteit',
  'settings.tabs.heading': 'Instellingen',
  'settings.tabs.resources': 'Resources',
  'settings.tabs.authentication': 'Authenticatie',
  'settings.tabs.userinterface': 'Gebruikersomgeving',

  'settings.ui.locale': 'Landinstelling',
  'settings.ui.language': 'Taal',

  'sidebar.button.feeds': 'Feeds',
  'sidebar.button.settings': 'Instellingen',
  'sidebar.button.speedlimits': 'Sneldheidsbeperkingen',

  'sidebar.search.placeholder': 'Zoek torrents',

  'sidebar.transferdata.downloaded': 'Gedownload',
  'sidebar.transferdata.uploaded': 'Geupload',

  'speed.unlimited': 'Ongelimiteerd',

  'unit.size.byte': 'B',
  'unit.size.kilobyte': 'kB',
  'unit.size.megabyte': 'MB',
  'unit.size.gigabyte': 'GB',
  'unit.size.terabyte': 'TB',
  'unit.speed': '{baseUnit}/s',
  'unit.time.year': 'j',
  'unit.time.week': 'w',
  'unit.time.day': 'd',
  'unit.time.hour': 't',
  'unit.time.minute': 'm',
  'unit.time.second': 'tw',
  'unit.time.infinity': '∞',

  'torrents.add.button.add': 'Torrent toevoegen',
  'torrents.add.destination.label': 'Downloadlocatie',
  'torrents.add.destination.placeholder': 'Downloadlocatie',
  'torrents.add.heading': 'Torrents toevoegen',
  'torrents.add.start.label': 'Start torrent',
  'torrents.add.tab.file.browse': 'of klik om te bladeren.',
  'torrents.add.tab.file.drop': 'Sleep bestanden hierheen,',
  'torrents.add.tab.file.title': 'Via bestand',
  'torrents.add.tab.url.input.placeholder': 'Torrent URL',
  'torrents.add.tab.url.title': 'Via URL',
  'torrents.add.torrents.label': 'Torrents',

  'torrents.details.actions.pause': 'Pauzeer',
  'torrents.details.actions.start': 'Start',
  'torrents.details.actions.stop': 'Stop',
  'torrents.details.details': 'Details',
  'torrents.details.files': 'Bestanden',
  'torrents.details.general.comment': 'Opmerking',
  'torrents.details.general.connected': '{connected} verbonden van {total}',
  'torrents.details.general.date.added': 'Toegevoegd op',
  'torrents.details.general.date.created': 'Aangemaakt op',
  'torrents.details.general.downloaded': 'Gedownload',
  'torrents.details.general.free.disk.space': 'Vrije schijfruimte',
  'torrents.details.general.hash': 'Hash',
  'torrents.details.general.heading.general': 'Algemeen',
  'torrents.details.general.heading.torrent': 'Torrent',
  'torrents.details.general.heading.tracker': 'Tracker',
  'torrents.details.general.heading.transfer': 'Overdracht',
  'torrents.details.general.location': 'Downloadlocatie',
  'torrents.details.general.none': 'Geen',
  'torrents.details.general.peers': 'Peers',
  'torrents.details.general.scheduler.ignored': 'Genegeerd',
  'torrents.details.general.scheduler.obeyed': 'Uitgevoerd',
  'torrents.details.general.scheduler': 'Scheduler',
  'torrents.details.general.seeds': 'Seeds',
  'torrents.details.general.size': 'Grootte',
  'torrents.details.general.tags': 'Tags',
  'torrents.details.general.tracker.message': 'Bericht van tracker',
  'torrents.details.general.type.private': 'Privé',
  'torrents.details.general.type.public': 'Publiek',
  'torrents.details.general.type': 'Type',
  'torrents.details.peers.no.data': 'Er zijn geen peer-gegevens voor deze torrent.',
  'torrents.details.peers': 'Peers',
  'torrents.details.selected.files': `{count, plural,
    =1 {{countElement} bestand geselecteerd}
    other {{countElement} bestanden geselecteerd}
  }`,
  'torrents.details.selected.files.set.priority': 'Wijzig prioriteit',
  'torrents.details.trackers.no.data': 'Er zijn geen tracker-gegevens voor deze torrent.',
  'torrents.details.trackers.type': 'Type',
  'torrents.details.trackers': 'Trackers',

  'torrents.list.clear.filters': 'Herstel filters',
  'torrents.list.context.check.hash': 'Controleer hash',
  'torrents.list.context.move': 'Downloadlocatie...',
  'torrents.list.context.pause': 'Pauzeer',
  'torrents.list.context.priority': 'Prioriteit',
  'torrents.list.context.remove': 'Verwijder',
  'torrents.list.context.set.tags': 'Tags instellen',
  'torrents.list.context.start': 'Start',
  'torrents.list.context.stop': 'Stop',
  'torrents.list.no.torrents': 'Geen torrents om te laten zien.',
  'torrent.list.peers': '{connected} {of} {total}',
  'torrent.list.peers.of': 'van',

  'torrents.move.button.set.location': 'Wijzig downloadlocatie',
  'torrents.move.button.state.setting': 'Wijzigen...',
  'torrents.move.data.label': 'Verplaats bestanden',
  'torrents.move.heading': 'Wijzig downloadlocatie',

  'torrents.properties.date.added': 'Datum toegevoegd',
  'torrents.properties.download.speed': 'Downloadsnelheid',
  'torrents.properties.download.total': 'Gedownload',
  'torrents.properties.eta': 'ETA',
  'torrents.properties.name': 'Naam',
  'torrents.properties.percentage': 'Percentage compleet',
  'torrents.properties.ratio': 'Ratio',
  'torrents.properties.size': 'Bestandsgrootte',
  'torrents.properties.upload.speed': 'Uploadsnelheid',
  'torrents.properties.upload.total': 'Geupload',

  'torrents.remove.are.you.sure': `Weet je zeker dat je {count, plural,
    =0 {geen torrents}
    =1 {één torrent}
    other {# torrents}
  } wilt verwijderen?`,
  'torrents.remove.error.no.torrents.selected': 'Je hebt geen torrents geselecteerd.',
  'torrents.remove': 'Torrents verwijderen',

  'torrents.set.tags.button.set': 'Tags instellen',
  'torrents.set.tags.heading': 'Tags instellen',

  'torrents.sort.title': 'Sorteer op'
};



// WEBPACK FOOTER //
// ./client/src/javascript/i18n/nl.js